export default "__VITE_ASSET__DqQUc4HC__"